<script>
	import Router from './routes/nonUserRoutes/index.svelte';
	import AdminRouter from './routes/adminRoutes/index.svelte';

	let isUserLogedIn = false;

	$:{
		if(localStorage.getItem('user') && localStorage.getItem('token')){

			// var user = localStorage.getItem('user');
			 
			isUserLogedIn = true;
		}
		else{
			
			isUserLogedIn = false;	
		}
	}
</script>



{#if isUserLogedIn}
	<AdminRouter/>
	
{:else}
	<Router/>
{/if}





